import React, { useEffect } from 'react'

const PostArchiveContext = React.createContext({})

export default function PostArchiveContainer ({
  children,
  postType = 'post',
  taxFilters = [],
  years = [],
  texts = []
}) {

  const [posts, setPosts] = React.useState(null)
  const [totalPosts, setTotalPosts] = React.useState(0)
  const [totalPages, setTotalPages] = React.useState(1)
  const [currentPage, setCurrentPage] = React.useState(1)
  const [isLoading, setIsLoading] = React.useState(false)
  const [containerRef, setContainerRef] = React.useState(null)
  const [searchParams, setSearchParams] = React.useState({
    postType: postType,
    page: 1,
    searchString: '',
    taxQuery: {},
    year: '',
    includedTaxQuery: Object.fromEntries(taxFilters
      .map(filter => [
        filter.taxonomy,
        filter?.terms?.map((term) => term.id) ?? []
      ])
      .filter(filter => filter[1].length > 0)
    )
  })

  return (
    <PostArchiveContext.Provider value={{
      posts,
      setPosts,
      totalPosts,
      setTotalPosts,
      totalPages,
      setTotalPages,
      currentPage,
      setCurrentPage,
      isLoading,
      setIsLoading,
      containerRef,
      setContainerRef,
      searchParams,
      setSearchParams,
      taxFilters,
      years,
      texts
    }}>
      { children }
    </PostArchiveContext.Provider>
  )
}

export { PostArchiveContext }
